<router-outlet></router-outlet>
<app-footer></app-footer>
<app-cookie-banner></app-cookie-banner>
